<template>
  <div id="app">
<!--    <Header />-->
    <router-view></router-view>
  </div>
</template>

<script>
// import Header from "./view/header"
import "@/style/index.less";

export default {
  name: "app",
  methods: {},
  // components: {
  //   Header
  // }
};
</script>
<style>
* {
  box-sizing: border-box;
}
</style>
